import { FocusMonitor } from '@angular/cdk/a11y';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  ElementRef,
  ChangeDetectorRef,
  NgZone
} from '@angular/core';
import { BaseFieldDirective } from '../base-field.directive';
import { CheckboxField } from './CheckboxField';

@Component({
    selector: 'ui-checkbox-field',
    templateUrl: './checkbox-field.component.html',
    styleUrls: ['./checkbox-field.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CheckboxFieldComponent extends BaseFieldDirective implements OnInit {

  @Input() public config!: CheckboxField;

  constructor(
      protected fmRef: FocusMonitor,
      protected elRef: ElementRef<HTMLElement>,
      protected changeDetector: ChangeDetectorRef,
      protected ngZone: NgZone
  ) {
    super(fmRef, elRef, changeDetector, ngZone);
  }

  ngOnInit() {
    super.ngOnInit();
  }


}
